import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

export default function Button(props) {
  const handleClick = (event) => {
    event.preventDefault();
    if (props.onClick !== undefined) {
      props.onClick(event);
    }
  };

  if (props.icon !== null) {
    return (
      <button
        className={
          'btn button' +
          (props.className !== undefined ? ' ' + props.className : '')
        }
        disabled={props.disabled}
        onClick={handleClick}
      >
        <img src={props.icon} alt="plus" />
        <span>{props.label}</span>
      </button>
    );
  } else {
    return (
      <input
        className={
          'btn button' +
          (props.className !== undefined ? ' ' + props.className : '')
        }
        disabled={props.disabled}
        value={props.label}
        type="button"
        onClick={handleClick}
      />
    );
  }
}

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  disabled: false,
  icon: null,
};



// WEBPACK FOOTER //
// ./src/components/shared/button/Button.js